import { render, staticRenderFns } from "./BuyProduct.vue?vue&type=template&id=704f51c2&scoped=true&"
import script from "./BuyProduct.vue?vue&type=script&lang=js&"
export * from "./BuyProduct.vue?vue&type=script&lang=js&"
import style0 from "./BuyProduct.vue?vue&type=style&index=0&id=704f51c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f51c2",
  null
  
)

export default component.exports